export { default as JobDetails } from "./JobDetails";
